import Vue from 'vue'
import './plugins/vuetify'
import './plugins/base'
import Home from './views/Home.vue'
import router from './routers/home'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(Home)
}).$mount('#app')
